import {
    CircularProgress,
    Box,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Stack,
    Typography,
    Card,
    CardContent,
    Grid,
} from "@mui/material";
import { useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import CardRating from "./CardRating";

interface IPropsRatingByClient {
    clients: any[]
}

const RatingByClient = ({ clients }: IPropsRatingByClient) => {
    const [selectedClient, setSelectedClient] = useState<string | null>(null);
    const [ratings, setRatings] = useState<any[]>([]);
    const [loadingRatings, setLoadingRatings] = useState<boolean>(false);

    const handleClear = () => {
        setSelectedClient(null);
        setRatings([]);
    };

    return (
        <Box sx={{ width: "100%", maxWidth: 1400, mx: "auto" }}>
            {/* Header and filters */}
            <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }} justifyContent="space-between">
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                            Seleccionar cliente
                        </Typography>
                        <FormControl fullWidth sx={{ maxWidth: 400 }}>
                            <InputLabel>Cliente</InputLabel>
                            <Select
                                value={selectedClient ?? ''}
                                onChange={(e) => setSelectedClient(e.target.value || null)}
                                label="Cliente"
                            >
                                <MenuItem value="">
                                    <em>-- Seleccione --</em>
                                </MenuItem>
                                {clients.map(c => (
                                    <MenuItem key={c.CardCode} value={c.CardCode}>
                                        {c.CardCode} — {c.CardName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    {selectedClient && (
                        <Button
                            variant="outlined"
                            color="error"
                            startIcon={<ClearIcon />}
                            onClick={handleClear}
                        >
                            Limpiar
                        </Button>
                    )}
                </Stack>
            </Paper>

            {/* Content area */}
            {loadingRatings ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            ) : selectedClient === null ? (
                <Card>
                    <CardContent>
                        <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                            Seleccione un cliente para ver sus calificaciones.
                        </Typography>
                    </CardContent>
                </Card>
            ) : ratings.length === 0 ? (
                <Card>
                    <CardContent>
                        <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
                            No hay calificaciones para este cliente.
                        </Typography>
                    </CardContent>
                </Card>
            ) : (
                <Grid container spacing={2}>
                    {ratings.map((r: any, i: number) => (
                        <Grid size={12} key={r.id || i}>
                            <CardRating
                                cardCode={r.id || String(i)}
                                cardName={r.cardName || `Calificación #${r.id || i}`}
                                comment={r.comment || '—'}
                                score={r.score !== undefined ? Number(r.score) : 0}
                                createdAt={r.createdAt ? new Date(r.createdAt).toLocaleDateString() : ''}
                                id={r.id || String(i)}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default RatingByClient;